import Header from "../../Components/Header"
import { useNavigate } from 'react-router-dom';
import { tabs, InnerGroupTypeList, isFeatureLocked } from "../../utils/state"
import { StateContext } from "../../services/context"
import { useContext, useState, useRef, useEffect } from "react"
import { RightArrowIcon, DownArrowIcon } from "../../utils/iconFactory";
import { SearchInput } from "../../Components/Elements/CustomInputs";
import { TemplateCardRow } from "../../Components/TemplateComponents";
import HelperModal, {HelperButton} from "../../Components/HelperComponents";



export default function Templates() {
  const navigate = useNavigate();
  const {user, setContentType} = useContext(StateContext)
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [helperModalVisible, setHelperModalVisible] = useState<boolean>(false);

  const atTheBottomRef = useRef<HTMLDivElement>(null);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const filteredTabs = tabs
  .map((item) => {
    if (Array.isArray(item.groupData)) {
      return {
        ...item,
        groupData: item.groupData.filter(
          (actualItem) =>
            actualItem.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            actualItem.description.toLowerCase().includes(searchQuery.toLowerCase())
        ),
      };
    } else {
      const filteredSubTests: InnerGroupTypeList = {};
      Object.keys(item.groupData).forEach((subTabKey) => {
        const subTestData = item.groupData as InnerGroupTypeList;
        const filteredSubTest = subTestData[subTabKey].filter(
          (actualItem) =>
            actualItem.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            actualItem.description.toLowerCase().includes(searchQuery.toLowerCase())
        );
        if (filteredSubTest.length > 0) {
          filteredSubTests[subTabKey] = filteredSubTest;
        }
      });

      return {
        ...item,
        groupData: filteredSubTests,
      };
    }
  })
  .filter((item) => {
    if (Array.isArray(item.groupData)) {
      return item.groupData.length > 0;
    } else {
      return Object.keys(item.groupData).length > 0;
    }
  });

  useEffect(() => {
    const atTheBottom = atTheBottomRef.current;
    
    if (atTheBottom) {
      const handleScroll = () => {
        const isBottom =
          atTheBottom.scrollTop + atTheBottom.clientHeight ===
          atTheBottom.scrollHeight;

        setIsAtBottom(isBottom);
      };

      atTheBottom.addEventListener('scroll', handleScroll);

      return () => {
        atTheBottom.removeEventListener('scroll', handleScroll);
      };
    }
  }, [atTheBottomRef]);


  return (
    <>
      <Header />
      <HelperModal isVisible={helperModalVisible} onClose={() => {setHelperModalVisible(false)}} modalContentType="template" />
      {!helperModalVisible && (<HelperButton onClick={() => setHelperModalVisible(true)} />)}
      <main className="flex flex-1 flex-col w-full overflow-y-auto no-scrollbar bg-backgroundLightGray" ref={atTheBottomRef} >
        <div className="flex w-full justify-center items-center">
          <div className="flex flex-col gap-4 w-[420px] text-center pb-10">
            <div className="h-[105px] bg-backgroundLightGray"/>
            <h1 className="text-style-h1">Szia, {user?.shopname}! 👋</h1>
            <p className="text-style-body1">Mit szeretnél ma írni az AIDA segítségével?</p>
            <SearchInput
              type="text"
              value={searchQuery}
              customAction={() => setSearchQuery("")}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Keresés..."
              spellCheck={false}
            />
            <p id='tip' className="text-style-body2 text-left">
              Ha még nem ismered az AIDA-t, nézd meg itt, hogyan és mire tudod használni
              {<RightArrowIcon onClick={() => setHelperModalVisible(true)} className="inline-flex cursor-pointer h-6 w-6 ml-2 mb-0.5 text-primaryAction fill-current" />}
            </p>
          </div>
        </div>
        <div id='template-card-section' className="flex flex-1 flex-col w-full border-t border-gray0 bg-backgroundWhite rounded-[16px] bg-drop-shadow px-10 py-8">
          {filteredTabs.map((item, index) => (
            <TemplateCardRow
              index={index}
              item={item}
              setContentType={setContentType}
              navigate={navigate}
              isLocked={isFeatureLocked(user.plan, item.componentName)}
            />
          ))}
        </div>
      </main>
      {
        !isAtBottom &&
        <div className="absolute bottom-4 right-4 flex gap-2 items-center">
          <p className="text-gray50 text-style-small">Görgess le</p>
          <DownArrowIcon className="h-12 w-12 text-gray10 fill-current" />
        </div>
      }
    </>
  )
}